import {Component} from 'substance'
import {Event} from '../../../../../lib/constants/Event'

class AboutComponent extends Component {

    constructor(...args) {
        super(...args)
    }

    getInitialState() {
        return {
            tab: 'settings',
            version: null
        }
    }

    didMount() {
        this.getVersion()
    }

    onChange(extension, key, value) {
        this.context.api.settings.set(
            extension.__namespace,
            key,
            value
        )

        this.context.api.events.trigger(
            null,
            Event.SETTINGS_CHANGED,
            {
                key: extension.__namespace + '.' + key,
                value: value
            }
        )
    }

    getVersion() {
        this.context.api.getVersion()
            .then(version => {
                this.extendState({
                    version: version
                })
            })
            .catch(() => {
                // Ignore it
            })
    }

    getSettings(extension) {
        return this.context.api.settings.getAllSettings(extension.__namespace)
    }

    render($$) {
        const popover = $$('div').addClass('sc-np-about-popover')
        const about = $$('div').append([
            this.renderVersion($$),
            $$('p').append(
                this.getLabel('Newspilot Writer is brought to you by Infomaker Scandinavia AB and was first released in early 2016.')
            ),
            this.appendCredits($$),
            $$('p').append([
                $$('a').attr({
                    'href': 'http://www.infomaker.se',
                    'target': '_blank'
                }).append('Infomaker Scandinavia AB')
            ]).css('text-align', 'right')
        ])

        const extensions = this.renderExtensions($$, about)
        if (extensions) {
            popover.addClass('sc-np-about-extended')
            popover.append(extensions)
        }
        else {
            popover.append(about)
        }

        popover.append(
            $$('div')
                .addClass('ui-about-footer')
                .append(
                    $$('button')
                        .addClass('sc-np-btn btn-secondary')
                        .append(
                            this.getLabel('Close')
                        )
                        .on('click', () => {
                            this.props.popover.close()
                        })
                )
        )

        return popover
    }


    appendCredits($$) {
        let el = $$('ul').addClass('fa-ul')

        el.append(
            $$('li').append(
                'Danne Lundqvist'
            )
                .addClass('fa-li fa fa-user')
        )

        el.append(
            $$('li').append(
                'Andreas Kihlberg'
            )
                .addClass('fa-li fa fa-user')
        )

        el.append(
            $$('li').append(
                'Ola Andersson'
            )
                .addClass('fa-li fa fa-user')
        )

        el.append(
            $$('li').append(
                'Tobias Södergren'
            )
                .addClass('fa-li fa fa-user')
        )

        el.append(
            $$('li').append(
                'Peter Persson'
            ).addClass('fa-li fa fa-user')
        )

        el.append(
            $$('li').append(
                'Christoffer Ekberg'
            ).addClass('fa-li fa fa-user')
        )

        el.append(
            $$('li').append(
                'Oscar Karlsson'
            ).addClass('fa-li fa fa-user')
        )

        el.append(
            $$('li').append(
                'Substance.io, FontAwesome.io'
            )
                .addClass('fa-li fa fa-code')
        )

        return $$('div')
            .addClass('ui-writer-credits')
            .append([
                $$('h3').addClass('clear').append(
                    this.getLabel('Core team and credits')
                ),
                el]
            )
    }

    renderExtensions($$, mainEl) {
        const extensionEls = []
        const extensionModules = this.context.configurator.getPluginModulesForTarget(
            'se.infomaker.npwriter.settings'
        )

        if (!Array.isArray(extensionModules) || extensionModules.length === 0) {
            return null
        }

        extensionEls.push(this.renderVersion($$))
        const defaultShowTextStyles = this.context.api.configurator.getWriterConfigValue('showTextStyles', false)

        extensionModules.forEach(extension => {
            extensionEls.push($$(extension, {
                properties: {visible: defaultShowTextStyles, ...this.getSettings(extension)},
                onChange: (key, value) => {
                    this.onChange(extension, key, value)
                }
            }))
        })

        return $$('fieldset').addClass('form-group').append(
            $$('div').addClass('form-group').append(
                this.renderExtensionsTab($$, mainEl, extensionEls)
            )
        )
    }

    renderExtensionsTab($$, mainEl, extensionEls) {
        const tabsEl = $$('div').addClass('ui-about-content').append([
            $$('div')
                .addClass('ui-about-tabs')
                .append([
                    $$('a')
                        .addClass(this.state.tab === 'settings' ? 'active' : '')
                        .on('click', (e) => {
                            e.preventDefault()
                            e.stopPropagation()

                            this.extendState({tab: 'settings'})
                            return false
                        })
                        .append(
                            this.getLabel('Settings')
                        ),
                    $$('a').append(this.getLabel('About'))
                        .addClass(this.state.tab === 'about' ? 'active' : '')
                        .on('click', (e) => {
                            e.preventDefault()
                            e.stopPropagation()

                            this.extendState({tab: 'about'})
                            return false
                        })
                ])
        ])

        if (this.state.tab === 'about') {
            tabsEl.append(
                $$('div').append(mainEl)
            )
        }
        else {
            tabsEl.append(
                $$('div')
                    .addClass('ui-about-extension-config')
                    .append(extensionEls)
            )
        }

        return tabsEl
    }

    renderVersion($$) {
        if (!this.state.version) {
            return null
        }

        return $$('div')
            .addClass('ui-writer-version')
            .append([
                $$('span').append('Newspilot Writer'),
                $$('strong').append(this.state.version)
            ])
    }
}

export default AboutComponent
